import {destroyCookie, parseCookies} from "nookies";
import {AxiosInstance} from "axios";
import {getValidationMessage} from "./apiError";
const axios = require('axios');

export function getAPIClient(ctx?: any) : AxiosInstance {
  const { 'nextauth.token': token } = parseCookies(ctx)

  const api = axios.create({
    baseURL: process.env.NEXT_PUBLIC_PUBLIC_PROXED_API,
    timeout: 9000
  })

  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  api.interceptors.response.use(
      (config: any) => config,
      (error: any) => {
          const validationMessage = getValidationMessage(error.response?.data);

          if (validationMessage) {
            error.response.data.message = validationMessage;
          }

          if (401 === error.response?.status) {

              destroyCookie(undefined, 'nextauth.token');
              destroyCookie(undefined, 'user.role')
              destroyCookie(undefined, 'nextauth.token', {path: '/'});
              destroyCookie(undefined, 'user.role', {path: '/'});

              if (typeof window !== 'undefined') {
                window.location.assign('/login');
              }

              return Promise.reject(error)
          } else {
              return Promise.reject(error);
          }
      }
  );

  return api;
}

export function getAPIServer() : AxiosInstance {
  return axios.create({
    baseURL: process.env.NEXT_PUBLIC_PUBLIC_API,
    timeout: 9000
  });
}
